/** Opens one machine in the Plant register from outside it (for example a
 * LOLER row in Home "Coming up"). PlantRegisterView is lazily loaded, so a
 * select event sent while it is unmounted has no listener. The request is
 * parked here and read when the register mounts, and also sent live for the
 * case where it is already open.
 *
 * It lapses after REQUEST_TTL_MS (long enough for a slow chunk load) and
 * browser Back or Forward drops it, so a stale request cannot hijack a later
 * visit to the register.
 */
import { PLANT_SELECT_EVENT } from '../features/plant/constants';

const REQUEST_TTL_MS = 30_000;

let pending: { assetId: string; at: number } | null = null;

export function clearRequestedPlantAsset(): void {
  pending = null;
}

export function takeRequestedPlantAsset(now: number = Date.now()): string | null {
  const request = pending;
  pending = null;
  return request && now - request.at <= REQUEST_TTL_MS ? request.assetId : null;
}

export function openPlantAsset(assetId: string): void {
  pending = { assetId, at: Date.now() };
  window.addEventListener('popstate', clearRequestedPlantAsset, { once: true });
  window.dispatchEvent(new CustomEvent('app:navigate', { detail: { view: 'assets' } }));
  window.dispatchEvent(new CustomEvent(PLANT_SELECT_EVENT, { detail: { id: assetId } }));
}
